import React from 'react';
import Button from '../Button/Button';

interface HelpCardProps {
  title: string;
  titleSize?: string;
  description: string;
  buttonText: string;
  buttonVariant: 'primary' | 'secondary';
  backgroundColor: string;
  buttonBorderColor?: string;
  textColor: string;
  backgroundImage: string;
  link?: string;
  onButtonClick?: () => void;
}

const HelpCard: React.FC<HelpCardProps> = ({
  title,
  titleSize: _titleSize = 'xl',
  description,
  buttonText,
  buttonVariant,
  buttonBorderColor = 'black',
  backgroundColor,
  textColor,
  backgroundImage,
  link,
  onButtonClick,
}) => {
  return (
    <div className="p-5 md:p-12 h-[565px] md:h-[365px] box-content group">
      <div className="help-card block md:flex rounded-2xl overflow-hidden relative h-full">
        <div
          className={`relative flex-1 flex flex-col justify-between p-8 rounded-2xl rounded-br-[100px] z-10 ${backgroundColor} ${textColor}`}
        >
          <div>
            <h3 className={`text-3xl mb-2`}>{title}</h3>
            <p className="text-base font-poppins mb-8 leading-[140%] w-5/6">{description}</p>
          </div>
          <div className="w-fit">
            <Button
              variant={buttonVariant}
              href={link}
              buttonBorderColor={buttonBorderColor}
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
          </div>
        </div>
        <div className="flex-1"></div>
        <div
          className="absolute z-0 h-full right-0 w-full bg-cover bg-right top-1/4 md:top-0"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        ></div>
      </div>
    </div>
  );
};

export default HelpCard;
